import http from '@/utils/http';

export default {
  list: (data) => http({ url: '/api/admin/v1/driverCert/list', data }),
  detail: (data) => http({ url: '/api/admin/v1/driverCert/detail', data }),
  audit: (data) => http({ url: '/api/admin/v1/driverCert/audit', data, tip: true }),
};
